import React from 'react';
import { Grid, Tooltip, useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SummaryParagraphSubHeader from '../SummaryParagraphSubHeader';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  paragraph: {
    letterSpacing: '0.1rem',
    color: theme.palette.texts.primary,
    maxWidth: '98%',
    whiteSpace: 'break-spaces',
    textOverflow: 'ellipsis',
    textTransform: 'uppercase',
    fontSize: theme.fonts.responsiveMedium,
    margin: '3px 0',
  },
}));

export default function PatientDetailItem(props) {
  const { t } = useTranslation();
  const theme = useTheme();
  const classes = useStyles();

  const { title, result } = props;

  return (
    <>
      <SummaryParagraphSubHeader subHeader={title} />
      <p className={classes.paragraph}>{result}</p>
    </>
  );
}
